export default {
  页面曝光: {
    f_module: '页面曝光',
    f_resource: '云首发',
    f_type: 0
  },
  支付面板: {
    支付面板: {
      f_module: '支付面板',
      f_resource: '支付面板',
      f_type: 1
    },
    为自己购买: {
      f_module: '支付面板',
      f_resource: '为自己购买',
      f_type: 4
    },
    为他人购买: {
      f_module: '支付面板',
      f_resource: '为他人购买',
      f_type: 4
    },
    开通会员: {
      f_module: '支付面板',
      f_resource: '开通会员',
      f_type: 4
    },
    增加: {
      f_module: '支付面板',
      f_resource: '增加',
      f_type: 4
    },
    减少: {
      f_module: '支付面板',
      f_resource: '减少',
      f_type: 4
    },
    输入份数: {
      f_module: '支付面板',
      f_resource: '输入份数',
      f_type: 4
    },
    立即支付: {
      f_module: '支付面板',
      f_resource: '立即支付',
      f_type: 4
    },
    关闭: {
      f_module: '支付面板',
      f_resource: '关闭',
      f_type: 4
    },
    ABTest: {
      f_module: '支付面板',
      f_resource: 'ABTest',
      f_type: 4
    }
  },
  订单列表: {
    订单列表: {
      f_module: '订单列表',
      f_resource: '订单列表',
      f_type: 1
    },
    抢光了: {
      f_module: '订单列表',
      f_resource: '抢光了',
      f_type: 4
    },
    继续分享: {
      f_module: '订单列表',
      f_resource: '继续分享',
      f_type: 4
    },
    查看领取好友: {
      f_module: '订单列表',
      f_resource: '查看领取好友',
      f_type: 4
    }
  },
  开通弹框: {
    开通弹框: {
      f_module: '开通弹框',
      f_resource: '开通弹框',
      f_type: 1
    },
    原价购买: {
      f_module: '开通弹框',
      f_resource: '原价购买',
      f_type: 4
    },
    开通会员: {
      f_module: '开通弹框',
      f_resource: '开通会员',
      f_type: 4
    },
    非会员无法开通: {
      f_module: '开通弹框',
      f_resource: '非会员无法开通',
      f_type: 4
    }
  },
  分享模块: {
    分享模块: {
      f_module: '分享模块',
      f_resource: '分享模块',
      f_type: 1
    },
    换图: {
      f_module: '分享模块',
      f_resource: '换图',
      f_type: 4
    },
    关闭: {
      f_module: '分享模块',
      f_resource: '关闭',
      f_type: 4
    }
  },
  领取弹框: {
    领取弹框: {
      f_module: '领取弹框',
      f_resource: '领取弹框',
      f_type: 1
    },
    立即领取: {
      f_module: '领取弹框',
      f_resource: '立即领取',
      f_type: 4
    },
    自己领取: {
      f_module: '领取弹框',
      f_resource: '自己领取',
      f_type: 4
    },
    关闭: {
      f_module: '领取弹框',
      f_resource: '关闭',
      f_type: 4
    }
  },
  领取列表弹框: {
    领取列表弹框: {
      f_module: '领取列表弹框',
      f_resource: '领取列表弹框',
      f_type: 1
    },
    我知道了: {
      f_module: '领取列表弹框',
      f_resource: '我知道了',
      f_type: 4
    }
  },
  头图: {
    头图: {
      f_module: '头图',
      f_resource: '头图',
      f_type: 1
    },
    头像: {
      f_module: '头图',
      f_resource: '头像',
      f_type: 4
    },
    播放: function _(txt) {
      return {
        f_module: '头图',
        f_resource: "\u64AD\u653E".concat(txt),
        f_type: 4
      };
    },
    活动规则: {
      f_module: '头图',
      f_resource: '活动规则',
      f_type: 4
    },
    关闭播放: {
      f_module: '头图',
      f_resource: '关闭播放',
      f_type: 4
    }
  },
  tab锚点: {
    tab锚点: {
      f_module: 'tab锚点',
      f_resource: 'tab锚点',
      f_type: 1
    },
    tab项目: function tab(txt) {
      return {
        f_module: 'tab锚点',
        f_resource: txt,
        f_type: 4
      };
    }
  },
  云首发介绍: {
    云首发介绍: {
      f_module: '云首发介绍',
      f_resource: '云首发介绍',
      f_type: 1
    },
    更多精彩: function _(name) {
      return {
        f_module: '云首发介绍',
        f_resource: "\u66F4\u591A\u7CBE\u5F69".concat(name),
        f_type: 4
      };
    }
  },
  线下活动: {
    线下活动: {
      f_module: '线下活动',
      f_resource: '线下活动',
      f_type: 1
    },
    活动展示: function _(name) {
      return {
        f_module: '线下活动',
        f_resource: "\u7EBF\u4E0B\u6D3B\u52A8".concat(name),
        f_type: 4
      };
    }
  },
  套餐购票: {
    套餐购票: {
      f_module: '套餐购票',
      f_resource: '套餐购票',
      f_type: 1
    },
    影片简介: {
      f_module: '套餐购票',
      f_resource: '影片简介',
      f_type: 4
    },
    购票权益: function _(txt) {
      return {
        f_module: '套餐购票',
        f_resource: "\u8D2D\u7968\u6743\u76CA".concat(txt),
        f_type: 4
      };
    }
  },
  抽奖模块: {
    抽奖模块: {
      f_module: '抽奖模块',
      f_resource: '抽奖模块',
      f_type: 1
    },
    抽奖: {
      f_module: '抽奖模块',
      f_resource: '抽奖',
      f_type: 4
    },
    去购票: {
      f_module: '抽奖模块',
      f_resource: '去购票',
      f_type: 4
    },
    去资产: {
      f_module: '抽奖模块',
      f_resource: '去资产',
      f_type: 4
    }
  },
  抽奖弹窗: {
    抽奖弹窗: function _(txt) {
      return {
        f_module: '抽奖弹窗',
        f_resource: "".concat(txt, "\u62BD\u5956\u5F39\u7A97"),
        f_type: 4
      };
    },
    立即查看: {
      f_module: '抽奖弹窗',
      f_resource: '立即查看',
      f_type: 4
    },
    我知道了: {
      f_module: '抽奖弹窗',
      f_resource: '我知道了',
      f_type: 4
    }
  },
  底部模块: {
    底部模块: {
      f_module: '底部模块',
      f_resource: '底部模块',
      f_type: 1
    },
    晒票根: {
      f_module: '底部模块',
      f_resource: '晒票根',
      f_type: 4
    },
    购票: {
      f_module: '底部模块',
      f_resource: '购票',
      f_type: 4
    },
    小鹅花钱: {
      f_module: '底部模块',
      f_resource: '小鹅花钱',
      f_type: 4
    }
  },
  明星排行榜模块: {
    明星排行榜模块: {
      f_module: '明星排行榜模块',
      f_resource: '明星排行榜模块',
      f_type: 1
    },
    我支持的演员: function _(starName) {
      return {
        f_module: '明星排行榜模块',
        f_resource: "\u6211\u652F\u6301\u7684\u6F14\u5458(".concat(starName, ")"),
        f_type: 4
      };
    },
    求支援: function _(starName) {
      return {
        f_module: '明星排行榜模块',
        f_resource: "\u6C42\u652F\u63F4(".concat(starName, ")"),
        f_type: 4
      };
    },
    加魂力: function _(starName) {
      return {
        f_module: '明星排行榜模块',
        f_resource: "\u52A0\u9B42\u529B(".concat(starName, ")"),
        f_type: 4
      };
    },
    电子相册: function _(starName) {
      return {
        f_module: '明星排行榜模块',
        f_resource: "\u7535\u5B50\u76F8\u518C(".concat(starName, ")"),
        f_type: 4
      };
    },
    独家花絮: function _(starName) {
      return {
        f_module: '明星排行榜模块',
        f_resource: "\u72EC\u5BB6\u82B1\u7D6E(".concat(starName, ")"),
        f_type: 4
      };
    },
    送魂力大图: function _(starName) {
      return {
        f_module: '明星排行榜模块',
        f_resource: "\u9001\u9B42\u529B\u5927\u56FE(".concat(starName, ")"),
        f_type: 4
      };
    },
    去得魂力: {
      f_module: '明星排行榜模块',
      f_resource: '去得魂力',
      f_type: 4
    },
    公告: {
      f_module: '明星排行榜模块',
      f_resource: '公告',
      f_type: 4
    }
  },
  使徒榜单: {
    使徒榜单: {
      f_module: '使徒榜单',
      f_resource: '使徒榜单',
      f_type: 1
    },
    tab: function tab(starName) {
      return {
        f_module: '明星排行榜模块',
        f_resource: "tab(".concat(starName, ")"),
        f_type: 4
      };
    },
    分享: {
      f_module: '使徒榜单',
      f_resource: '分享',
      f_type: 4
    },
    公告: {
      f_module: '使徒榜单',
      f_resource: '公告',
      f_type: 4
    }
  },
  选演员面板: {
    选演员面板: {
      f_module: '选演员面板',
      f_resource: '选演员面板',
      f_type: 1
    },
    演员: function _(starName) {
      return {
        f_module: '选演员面板',
        f_resource: "\u6F14\u5458".concat(starName),
        f_type: 4
      };
    }
  },
  送魂力面板: {
    送魂力面板: {
      f_module: '送魂力面板',
      f_resource: '送魂力面板',
      f_type: 1
    },
    增加魂力: {
      f_module: '送魂力面板',
      f_resource: '增加魂力',
      f_type: 4
    },
    减少魂力: {
      f_module: '送魂力面板',
      f_resource: '减少魂力',
      f_type: 4
    },
    输入魂力: {
      f_module: '送魂力面板',
      f_resource: '输入魂力',
      f_type: 4
    },
    魂力守护按钮: {
      f_module: '送魂力面板',
      f_resource: '魂力守护按钮',
      f_type: 4
    },
    '魂力展示-继续购票送魂力': {
      f_module: '送魂力面板',
      f_resource: '魂力展示-继续购票送魂力',
      f_type: 4
    }
  },
  魂力分享图: {
    魂力分享图: {
      f_module: '魂力分享图',
      f_resource: '魂力分享图',
      f_type: 1
    },
    海报: {
      f_module: '魂力分享图',
      f_resource: '海报',
      f_type: 2
    }
  },
  书券: {
    书券: {
      f_module: '书券',
      f_resource: '书券',
      f_type: 1
    },
    领取书券: {
      f_module: '书券',
      f_resource: '领取书券',
      f_type: 4
    },
    去阅读: {
      f_module: '书券',
      f_resource: '去阅读',
      f_type: 4
    },
    已领完: {
      f_module: '书券',
      f_resource: '已领完',
      f_type: 4
    }
  }
};